import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return { "text": String }
  }

  reset() {
    this.element.classList.remove("h-button--success-light")
    this.element.classList.remove("h-button--danger-light")
    this.element.innerHTML = this.textValue
  }
}
